import { LinearProgress, makeStyles } from "@material-ui/core";
import { OverviewSearchBox } from "./OverviewSearchBox";
import { IOverviewSelectProps, OverviewSelect } from "./OverviewSelect";

const useStyles = makeStyles({
    root: {
        margin: "0.5rem 0",
        padding: "0 1rem 1rem 1rem"
    },
    searchRoot: {
        paddingBottom: "1rem"
    }
})



interface IProps extends IOverviewSelectProps {
    setSearchText: (searchText: string) => void;
    isLoading: boolean;
}

export function OverviewSearch({ setSearchText, isLoading, selected, onSelected }: IProps) {
    const { root, searchRoot } = useStyles();
    return <div className={root}>
        <div className={searchRoot}>
            <OverviewSearchBox onSearch={setSearchText} />
            {isLoading && <LinearProgress />}
        </div>
        <div>
            <OverviewSelect selected={selected} onSelected={onSelected} />
        </div>
    </div>
}